import React, { useState } from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { DropdownCellRendererProps } from '../Common/CellRendererProps';

export const DropdownCellRenderer: React.FC<DropdownCellRendererProps> = (props) => {
  const [value, setValue] = useState<string | number>(props.data[props.column.colId] || '');
  const options = props.colDef.cellEditorParams?.options || [];

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    const newValue = event.target.value;
    setValue(newValue);
    props.node.setDataValue(props.column.colId, newValue);
    
    if (props.context?.onCellUpdate) {
      props.context.onCellUpdate(props.data, props.column.colId, newValue);
    }
  };

  return (
    <FormControl size="small" fullWidth>
      <Select
        value={value}
        onChange={handleChange}
        variant="outlined"
      >
        <MenuItem value="">
          <em>Seleccionar</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name || option.code}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};